import React, { useState } from 'react'
import { CONFIG } from './config'
import styled from 'styled-components'
import { Waypoint } from 'react-waypoint'

/**
 * Component for Scrollytelling
 *
 * Elements for front layer
 * @prop {React.ReactChild[]} front
 *
 * Function returning background layer element
 * index = current visible front layer element
 * @prop {( index:Number )=> React.ReactChild } background
 *
 * gap between the front layer elements as viewport height
 * @prop { Number } distance
 *
 * space after last front element as viewport height
 * @prop { Number } endSpace
 *
 * @returns { React.Element } React Component
 */

export const Scroller = ({
  front,
  back,
  defaultDistance = CONFIG.default.spacerHeight,
  className,
  headerHeight,
}: {
  front: JSX.Element[]
  back: (e: number, o: { [key: string]: any }) => JSX.Element
  defaultDistance?: number
  className?: string
  headerHeight?: number
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  return (
    <StyledScroller className={'Scroller ' + className} id='scroller' headerHeight={headerHeight}>
      <div className='back' id='back'>
        {back(currentIndex, front[currentIndex])}
      </div>
      <div className='front'>
        {front.map((element, i) => {
          let d = element.props.distance || defaultDistance || 100
          return (
            <React.Fragment key={'Front_' + i}>
              <Waypoint
                scrollableAncestor={window}
                onEnter={() => setCurrentIndex(i)}
                onLeave={(e) => {
                  let newindex = i + (e.currentPosition === 'below' ? -1 : 1)
                  setCurrentIndex(newindex)
                }}
              >
                <div>{element}</div>
              </Waypoint>
              <Spacer style={{ minHeight: d + 'px' }} />
            </React.Fragment>
          )
        })}
      </div>
    </StyledScroller>
  )
}

const Spacer = styled.div`
  pointer-events: none;
`
const StyledScroller = styled.div<{ headerHeight?: number }>`
  position: relative;
  display: block;
  transform: translateZ(0);
  backface-visibility: hidden;

  .back {
    z-index: 1;
    position: sticky;
    top: ${({ headerHeight }) => headerHeight ?? 0}px;
  }

  .front {
    position: relative;
    z-index: 20;
    width: 100%;
    transform: translateY(-50vh);
    pointer-events: none;
  }
`
